import styled from "styled-components/macro";
import { Link as RRLink } from "react-router-dom";
import { HTMLAttributes } from "react";

export default function PageSmall({
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <Container {...props}>
      {children}
      <Footer>
        <div>
          <div>
            Can't Log In? <Link to="/password-reset">Reset Password</Link>
          </div>
          <div style={{ textAlign: "right" }}>
            Need an Account?{" "}
            <Link as="a" href="https://skipio.com">
              Get Started
            </Link>
          </div>
        </div>
        <div>
          <div>
            <Link to="/login">Login</Link> •{" "}
            <Anchor target="_blank" href="https://www.skipio.com/terms">
              Terms
            </Anchor>{" "}
            &bull;{" "}
            <Anchor target="_blank" href="https://www.skipio.com/terms">
              Privacy Policy
            </Anchor>
          </div>
          <div>
            <span className="copyright">
              ©{new Date().getFullYear()} Skipio. All rights reserved.
            </span>
          </div>
        </div>
      </Footer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #d7d7d9;
  padding: 20px;
  min-height: 100vh;
  background: #0a344a;
  overflow-y: auto;

  & > div {
    margin: 0px auto;
    max-width: 440px;
    border-radius: 8px;
    min-height: 100px;
    margin-bottom: 10px;
    @media (min-width: 800px) {
      width: 440px;
    }
    &:first-child {
      padding: 10px 30px;
      background: white;
      text-align: left;
      color: #676163;
      margin-bottom: 20px;
    }
  }
`;

const Footer = styled.div`
  font-size: 12px;
  & > div:first-child {
    display: flex;
    & > div {
      flex-grow: 1;
      margin-right: 10px;
    }
  }
  & > div:last-child {
    text-align: center;
    margin-top: 10px;
    & > div {
      margin-bottom: 10px;
      &:last-child {
        opacity: 0.5;
      }
    }
    a {
      color: rgba(255, 255, 255, 0.5);
    }
  }
`;

const Link = styled(RRLink)`
  color: #0094de;
  text-decoration: none;
  &:hover {
    color: #006192;
    text-decoration: none;
  }
  &:visited {
    color: #0094de;
  }
`;

const Anchor = styled.a`
  text-decoration: none;
`;
